<h3 class="ui primary header">
  {{ modal.context.title }}
  <i class="link times icon" (click)="modal.deny(undefined)"></i>
</h3>
<div class="content">
  <div *ngIf="success || error" tamsyMargin marginY="10px">
    <esl-message-toast [(message)]="success" [messageType]="'success'"></esl-message-toast>
    <esl-message-toast [(message)]="error"></esl-message-toast>
  </div>
  <div class="scroll-wrapper ui basic segment" [ngClass]="{ loading: pending }">
    <app-tabset>
      <div class="ui pointing secondary menu" appMargin marginB="1">
        <a class="item" appPadding paddingL="0" appTabHeader="1">New Users</a>
        <a class="item" appPadding paddingL="0" appTabHeader="2"
          >Existing Users</a
        >
      </div>
      <div class="ui vertical basic segment" appTabContent="1">
        <h3 class="">All users in no unit</h3>
        <app-no-record-found
          *ngIf="noUnitUsers && noUnitUsers.length < 1"
        ></app-no-record-found>

        <div
          class="ui segment"
          *ngFor="let user of noUnitUsers"
          appMargin
          marginB="5"
        >
          <div
            fxLayout="row"
            fxLayoutAlign="space-between center"
            fxLayoutGap="15px"
          >
            <div fxFlex="10%">
              <img class="ui circular tiny image" src="assets/avatar/1.jpg" />
            </div>
            <div fxFlex="grow">
              <h4 class="sub-header">
                {{ user?.firstName }} {{ user?.middleName }}
                {{ user?.lastName }}
              </h4>
            </div>
            <div fxFlex="10%">
              <sui-checkbox [(ngModel)]="user.selected"></sui-checkbox>
            </div>
          </div>
        </div>
      </div>
      <div class="ui vertical basic segment" appTabContent="2">
        <h3>All users in this unit</h3>
        <app-no-record-found
          *ngIf="unitUsers && unitUsers.length < 1"
        ></app-no-record-found>

        <div
          class="ui segment"
          *ngFor="let user of unitUsers"
          appMargin
          marginB="5"
        >
          <div
            fxLayout="row"
            fxLayoutAlign="space-between center"
            fxLayoutGap="15px"
          >
            <div fxFlex="10%">
              <img class="ui circular tiny image" src="assets/avatar/1.jpg" />
            </div>
            <div fxFlex="grow">
              <h4 class="sub-header">
                {{ user?.firstName }} {{ user?.middleName }}
                {{ user?.lastName }}
              </h4>
            </div>
            <div fxFlex="10%">
              <!-- <sui-checkbox [(ngModel)]="user.selected" (checkChange)="removeUser($event,user)"></sui-checkbox> -->
              <button class="ui tiny icon button" (click)="onDelete(user)">
                <i class="ui trash icon"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </app-tabset>
  </div>
</div>
<div class="actions">
  <button class="ui basic primary button" (click)="modal.deny(undefined)">
    Cancel
  </button>
  <button
    class="ui primary button"
    [ngClass]="{ yellow: pending }"
    [disabled]="pending"
    (click)="submit()"
    autofocus
  >
    Done
  </button>
</div>
